var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankmoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14.667,
    viewBox: "0 0 16 14.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_311",
    "data-name": "Union 311",
    d: "M0,14.667v-1H1.333V6.5A1.168,1.168,0,0,1,2.5,5.333h3v1h-3a.166.166,0,0,0-.167.166v7.167H13.667V9.833h1v3.834H16v1ZM7.333,4.333a4.333,4.333,0,1,1,4.333,4.333A4.338,4.338,0,0,1,7.333,4.333Zm1,0A3.333,3.333,0,1,0,11.666,1,3.337,3.337,0,0,0,8.333,4.333ZM11.166,7V6.38h-.833v-1h1.472c.092,0,.194-.112.194-.274s-.1-.274-.194-.274h-.278a1.238,1.238,0,0,1-1.195-1.274,1.269,1.269,0,0,1,.834-1.214V1.667h1v.619H13v1H11.528c-.092,0-.194.112-.194.273s.1.274.194.274h.278A1.238,1.238,0,0,1,13,5.107a1.269,1.269,0,0,1-.834,1.214V7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankmoney);
export default __webpack_public_path__ + "static/media/bankmoney.0665cc7866a39aa2258df958bc6db339.svg";
export { ForwardRef as ReactComponent };